module.exports = __webpack_public_path__ + "static/media/sbe.6967a7c3.png";